module.exports = __webpack_public_path__ + "static/media/hs_01.c5bbbfda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_01.jpg
// module id = 5932
// module chunks = 0